<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <v-btn fab dark small color="amber darken-2" @click="playData()">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="refreshData()"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>
            <add-button
              v-if="$moduleAccess('add_master_card_contact_number')"
              @add="openAddDialog"
            ></add-button>

            <!-- Dialog for Add View Edit -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>                
                <v-flex md12>
                  <details-container
                    ref="detailsRef"
                    :dialogType="dialogType"
                    :data="viewData"
                    :contacts="contacts"
                    :companies="companies"
                    :subcompanies="subcompanies"
                    :readonly="dialogType === 'view'"
                    :counter="dialogType != 'view'"
                  />
                </v-flex>
               
              </v-container>
            </action-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
                dialogType === 'add'
                  ? saveAddDialog()
                  : dialogType === 'edit'
                  ? saveEditDialog()
                  : ''
              "
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>

          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">{{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="By Company"
                solo
                clearable
              ></v-select>
            </v-flex>
            <v-flex md4>
              <v-select
                v-model="filterSubCompany"
                :items="filterSubCompanies"
                label="By Sub-Company"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                >
                  <span>{{ header.text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{ props.item.first_name + " " + props.item.last_name }}
              </td>
              <td class="text-xs-center">{{ props.item.contact_no }}</td>
              <td class="text-xs-left text-uppercase">
                {{
                  props.item.company_id === null
                    ? "--"
                    : props.item.company.name
                }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{
                  props.item.sub_company_id === null
                    ? "--"
                    : props.item.sub_company.name
                }}
              </td>
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <edit-button
                  v-if="$moduleAccess('edit_master_card_contact_number')"
                  @edit="openEditDialog(props.item)"
                ></edit-button>
                <delete-button
                  v-if="$moduleAccess('delete_master_card_contact_number')"
                  @delete="openDeleteDialog(props.item)"
                ></delete-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/MasterCardContactNumberDetailsContainer";
import XLSX from "xlsx";
var now = new Date();

export default {
  components: {
    DetailsContainer,
  },
  data() {
    return {
      items: [],
      companies: [],
      subcompanies: [],
      contacts: [],
      filterCompanies: [],
      filterSubCompanies: [],
      filterCompany: "",
      filterSubCompany: "",
      // assignCompany: "",
      // assignSubCompany: "",
      openFilter: false,
      openPanel: [true],
      e1: 0,
      title: "Master Card Contact Number",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Contact Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Contact No.",
          align: "center",
          value: "contact_no",
          sortable: false,
        },
        {
          text: "Company",
          align: "left",
          value: "company",
          sortable: false,
        },
        {
          text: "Subcompany",
          align: "left",
          value: "sub_company",
          sortable: false,
        },
        {
          text: "Actions",
          align: "center",
          value: "contact_no",
          sortable: false,
        },
      ],
      data: {},
      viewData: {},
      valid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        counter: (value) => {
          if (value !== undefined) {
            if (value.length === 9) {
              return true;
            } else {
              return "Must be 9 digits";
            }
          } else {
            return true;
          }
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        name: (value) => {
          const pattern = /^[ñA-Za-z\s',._-]+$/;
          if (pattern.test(value)) {
            return true;
          } else {
            return "Invalid name.";
          }
        },
        contact: (value) => {
          const pattern = /^[0-9]*$/;
          if (pattern.test(value)) {
            return true;
          } else {
            return "Invalid contact number.";
          }
        },
      },

      queryParams: {
        search: null,
        limit: 10,
        offset: 0,
      },
      totalItems: 0,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      confirmLoading: false,
      deleteDialog: false,
      dateFromMenu: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateToMenu: false,
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
        { text: 60, value: 60 },
        { text: 70, value: 70 },
        { text: 80, value: 80 },
        { text: 90, value: 90 },
        { text: 100, value: 100 },
      ],
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      disabledLimit: true,
      deleteType: "",
      editContactNumberDialog: false,
    };
  },
  created: async function() {
    await this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.getData();
      }
    },
    filterSubCompany: async function() {
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = this.filterSubCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = null;
        this.getData();
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      //this.getData();
    },
    async playData() {
      this.items = [];

      this.getData();
    },
    async getData() {
      // Start Loading
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getMasterCardContacts(this.queryParams))
          .data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }

        if (this.totalItems <= this.queryParams.limit) {
          this.disabledLimit = true;
        } else {
          this.disabledLimit = false;
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network connection",
          });
        }
      }
      this.$store.dispatch("endLoading");
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      this.viewData.id = "";
      this.viewData.mastercard_contact_id = "";
      this.viewData.first_name = "";
      this.viewData.last_name = "";
      this.viewData.assignCompany = "";
      this.viewData.assignSubCompany = "";
      this.viewData.contact_no = "";

      await this.setCompanies();

      this.companies = await this.setCompanies();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
      this.e1 = 1;
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      const returnedData = await this.setData(data);

      this.viewData.id = returnedData.id;
      this.viewData.mastercard_contact_id = "";
      this.viewData.first_name = returnedData.first_name;
      this.viewData.last_name = returnedData.last_name;
      this.viewData.assignCompany = returnedData.assignCompany;
      this.viewData.assignSubCompany = returnedData.assignSubCompany;
      this.viewData.contact_no = returnedData.contact_no;

      this.companies = await this.setCompanies();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;
      this.editMasterCardContact = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      const returnedData = await this.setData(data);

      this.viewData.id = returnedData.id;
      this.viewData.mastercard_contact_id = "";
      this.viewData.first_name = returnedData.first_name;
      this.viewData.last_name = returnedData.last_name;
      this.viewData.assignCompany = returnedData.assignCompany;
      this.viewData.assignSubCompany = returnedData.assignSubCompany;
      this.viewData.contact_no = returnedData.contact_no;      

      this.companies = await this.setCompanies();

      this.data.id = data.id;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.data.id = data.id;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async closeDialog() {
      if (
        (this.dialogLoading === false && this.dialogType === "add") ||
        (this.dialogLoading === false && this.dialogType === "edit")
      )
        // {
        //   this.$refs.formCompany.reset();
        //   this.$refs.formSubCompany.reset();
        //   this.$refs.formContact.reset();
        // }

        this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    saveDialog() {
      // if (this.$refs.formContact.validate()) {
      this.openConfirmDialog = true;
      // }
    },
    async setCompanies() {
      let finalData = [];

      const items = (
        await Services.getCompanies({
          project_id: this.$store.state.employee.project_id,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        finalData.push(data);
      }

      // if (this.setCompanies) {
      //   this.subcompanies = await this.setSubCompanies();
      //   this.contacts = await this.setContactEdit();
      // }

      return finalData;
    },
    async setSubCompanies() {
      let finalData = [];
      const items = (
        await Services.getSubCompanies({
          // project_id: this.$store.state.employee.project_id,
          company_id: this.viewData.company_name,
        })
      ).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        finalData.push(data);
      }

      return finalData;
    },
    async setContactEdit() {
      let finalData = [];

      const items = (await Services.getMasterCardContacts({})).data;

      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text:
            el[i].first_name.toUpperCase() +
            " " +
            el[i].last_name.toUpperCase(),
          value: el[i].id,
        };
        finalData.push(data);
      }
      return finalData;
    },
    async eTwo() {
      if (this.$refs.formCompany.validate()) {
        this.e1 = 2;
        await this.setSubCompanies();
      }
    },
    eThree() {
      if (this.$refs.formSubCompany.validate()) {
        this.e1 = 3;
      }
    },
    async openFilterExpansion() {
      this.openFilter = !this.openFilter;
      await this.setFilterItems();
    },
    async setFilterItems() {
      this.filterCompanies = [];
      this.filterSubCompanies = [];

      const items = (await Services.getMasterCardContacts({})).data;

      let companies = [],
        subCompanies = [];

      for (var i = 0, el = items.data; i < el.length; i++) {
        let dataCompanies = {
          text: el[i].company.name.toUpperCase(),
          value: el[i].company_id,
        };

        let dataSubCompanies = {
          text: el[i].sub_company.name.toUpperCase(),
          value: el[i].sub_company_id,
        };

        companies.push(dataCompanies);
        subCompanies.push(dataSubCompanies);
      }

      // The Code below here filters the objects that has duplicates...

      this.filterCompanies = Array.from(
        new Set(companies.map(JSON.stringify))
      ).map(JSON.parse);

      this.filterSubCompanies = Array.from(
        new Set(subCompanies.map(JSON.stringify))
      ).map(JSON.parse);
    },
    async setData(items) {
      let data = {
        id: items.id,
        first_name: items.first_name.toUpperCase(),
        //  + " " + items.last_name.toUpperCase(),
        last_name: items.last_name.toUpperCase(),
        // assignCompany: compName[0].value,
        assignCompany: items.company_id,
        assignSubCompany: items.sub_company_id,
        contact_no: items.contact_no.slice(2),
      };

      return data;
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const conData = await this.$refs.detailsRef.computedData;

      const body = {
        // first_name: this.data.first_name,
        // last_name: this.data.last_name,
        // contact_no: "639" + this.data.contact_no,
        // company_id: this.assignCompany.value,
        // sub_company_id: this.assignSubCompany.value,
        id: conData.id,
        first_name: conData.first_name,
        last_name: conData.last_name,
        contact_no: "63" + conData.contact_no,
        company_id: conData.assignCompany,
        sub_company_id: conData.assignSubCompany,
      };

      try {
        const response = await Services.addMasterCardContact(body);

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Master Card Contact Number has been added!",
          });
        } else {
          this.closeConfirmDialog();
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;
      const conData = await this.$refs.detailsRef.computedData;

      const body = {
        id: conData.id,
        first_name: conData.first_name,
        last_name: conData.last_name,
        contact_no: "63" + conData.contact_no,
        company_id: conData.assignCompany,
        sub_company_id: conData.assignSubCompany,
      };

      try {
        const response = await Services.editMasterCardContact(body.id, body);

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Master Card Contact Number has been Edited!",
          });
        } else {
          this.closeConfirmDialog();
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 404) {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          } else {
            this.$infoBar({
              type: "error",
              text: this.titleCase(error.response.data.message) + "!",
            });
          }
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteMasterCardContact(this.data.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Master Card Contact Number has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    titleCase(str) {
      let splitStr = str.toLowerCase().split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(" ");
    },
    refreshData() {
      this.$refs.searchRef.clear();
      this.filterCompany = null;
      this.filterSubCompany = null;
      this.getData();
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async downloadExcel() {
      this.$store.dispatch("startLoading");

      this.items = [];

      const response2 = (
        await Services.getTransactionSync({
          offset: 0,
          transaction_type_id: null,
          date_from: this.dateFrom + " " + this.timeFrom + ":00",
          date_to: this.dateTo + " " + this.timeTo + ":59",
        })
      ).data;

      this.items = response2.data;

      let dataToDownload = [];
      let header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text);
      }
      header.shift();
      header.pop();
      dataToDownload.push(header);

      for (let e = 0; e < this.items.length; e++) {
        let theItem = [];

        theItem.push(this.items[e].sub_company.code);
        theItem.push(
          this.items[e].card_shift_sync === null
            ? ""
            : this.items[e].card_shift_sync.control_no
        );
        theItem.push(this.items[e].device.device_serial);
        theItem.push(this.items[e].terminal.name.toUpperCase());
        theItem.push(
          this.$dateFormat(this.items[e].transaction_date, "YYYY-MM-DD")
        );
        theItem.push(this.$dateFormat(this.items[e].transaction_date, "HH:mm"));
        theItem.push(this.items[e].transaction_no);
        theItem.push(this.items[e].trace_no);
        theItem.push(this.items[e].card_no);
        theItem.push(this.items[e].transaction_type.name.toUpperCase());
        theItem.push(this.items[e].previous_balance);
        theItem.push(this.items[e].card_amount);
        theItem.push(this.items[e].remaining_balance);
        theItem.push(
          (this.items[e].user.first_name === undefined ||
          this.items[e].user.first_name === null
            ? ""
            : this.items[e].user.first_name) +
            " " +
            (this.items[e].user.middle_name === undefined ||
            this.items[e].user.middle_name === null
              ? ""
              : this.items[e].user.middle_name) +
            " " +
            (this.items[e].user.last_name === undefined ||
            this.items[e].user.last_name === null
              ? ""
              : this.items[e].user.last_name)
        );

        dataToDownload.push(theItem);
      }

      this.$store.dispatch("endLoading");

      // don't delete any codes after this comment got it?!

      var wscols = [
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
        { wch: 35 }, // "pixels"
      ];

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      // var wsname = "SheetJS";

      var fmt = "#,##0";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }
      // wb.SheetNames.push(wsname);
      // wb.Sheets[wsname] = ws;
      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      // ws["!protect"] = {
      //   password: "Journeytech@1",
      //   formatRows: false,
      //   formatColumns: false,
      //   objects: true,
      //   scenarios: true
      // };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
